import TYPES from './TYPES';

export const toggleMainNav = (dispatch, isOpen) =>
  dispatch({
    type: TYPES.SET_IS_OPEN,
    payload: {
      isOpen,
    },
  });
